import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

const Unauthorized = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        p: 2
      }}
    >
      <Paper 
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 2,
          maxWidth: 500,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            backgroundColor: 'error.light',
            borderRadius: '50%',
            p: 2,
            mb: 3
          }}
        >
          <LockIcon sx={{ fontSize: 60, color: 'error.main' }} />
        </Box>
        
        <Typography variant="h4" sx={{ mb: 2 }}>
          Access Denied
        </Typography>
        
        <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
          You don't have permission to access this page. Please contact your administrator if you believe this is an error.
        </Typography>
        
        <Button 
          variant="contained" 
          color="primary" 
          component={RouterLink} 
          to="/dashboard"
        >
          Back to Dashboard
        </Button>
      </Paper>
    </Box>
  );
};

export default Unauthorized;